import { StyledMenuItem } from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/forms/StyledComponents";
import { RadioButtons } from "@egovernments/digit-ui-react-components";
import { FormControl } from "@material-ui/core";
import { Box, Grid, OutlinedInput, Select } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
const OnSelectActionDropdown = ({ actions, currentAction, onChange }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1} style={{ margin: "4px 0px", alignItems: "center" }}>
        <Box gridColumn="span 2" style={{ display: "flex", paddinfLeft: "4px", alignItems: "center" }}>
          <b style={{marginLeft:"30px"}}>Action </b>
        </Box>
        <Box gridColumn="span 10">
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <Select
              // displayEmpty
              value={currentAction}
              label="Select Action"
              onChange={onChange}
              sx={{ width: "18.25vw", borderRadius: "1px" }}
              size="small"
              variant="outlined"
              required={false}
              input={<OutlinedInput />}
              renderValue={(selected) => {
                if (!selected || !selected.action) {
                  return <p>Select Action</p>;
                }
                return t(selected.action);
              }}
            >
              <StyledMenuItem disabled value="" key="Select Action">
                <em>Select Action</em>
              </StyledMenuItem>
              {actions &&
                actions?.map((item) => {
                  const dropdowns = item?.action;
                  return (
                    <StyledMenuItem
                      value={item}
                      key={dropdowns}
                      // className={width && "customWidth"}
                    >
                      {t(`${dropdowns}`)}
                    </StyledMenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default OnSelectActionDropdown;
